import { ItemStatusBadge } from '@/components/badges/ItemStatusBadge'
import { ItemStatusIcon } from '@/components/ItemStatusIcon'
import { ItemStatus } from '@/constants/item'
import { useTranslation } from 'react-i18next'

export function ItemStats({
  title,
  subtitle,
  status,
  days,
}: {
  title?: string | null
  subtitle?: string | null
  status?: ItemStatus
  days?: number | null
}) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-between rounded-lg border border-border/30 bg-secondary/20 p-3">
      <div className="flex items-center gap-3">
        {status && <ItemStatusIcon status={status} />}
        <div className="flex flex-col gap-0.5">
          <span className="text-xs font-medium text-foreground">{title}</span>
          <span className="text-[10px] text-muted-foreground">{subtitle}</span>
        </div>
      </div>
      <div className="flex flex-col gap-0.5 text-[10px]">
        {status && <ItemStatusBadge status={status} />}
        {days != null && <span className="text-end">{t('common.day', { count: days })}</span>}
      </div>
    </div>
  )
}
